import { motion, useReducedMotion } from "framer-motion";
import type { FunnelStage } from "../mockAnalytics";

interface ConversionFunnelProps {
  data: FunnelStage[];
}

const STAGE_COLORS = ["bg-primary", "bg-info", "bg-warning", "bg-success"];

/** Stepped horizontal-bar funnel: Messages -> Engaged -> Leads -> Converted, with drop-off %. */
export function ConversionFunnel({ data }: ConversionFunnelProps) {
  const prefersReducedMotion = useReducedMotion();
  const max = data[0]?.value || 1;

  return (
    <div className="space-y-3">
      {data.map((stage, i) => {
        const widthPct = Math.max(6, (stage.value / max) * 100);
        const prev = i > 0 ? data[i - 1].value : null;
        const dropOffPct = prev ? Math.round(((prev - stage.value) / prev) * 100) : null;
        return (
          <div key={stage.stage}>
            <div className="mb-1 flex items-center justify-between text-xs">
              <span className="font-medium text-slate-700 dark:text-slate-300">{stage.stage}</span>
              <span className="flex items-center gap-2 tabular-nums text-muted-foreground">
                {dropOffPct !== null && (
                  <span className="text-error">-{dropOffPct}%</span>
                )}
                <span className="font-semibold text-slate-900 dark:text-white">{stage.value.toLocaleString()}</span>
              </span>
            </div>
            <div className="h-8 w-full overflow-hidden rounded-md bg-slate-100 dark:bg-slate-800">
              <motion.div
                className={`flex h-full items-center rounded-md ${STAGE_COLORS[i % STAGE_COLORS.length]}`}
                initial={{ width: prefersReducedMotion ? `${widthPct}%` : 0 }}
                animate={{ width: `${widthPct}%` }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
